var map = {
	"./symbol_0.png": "efe3",
	"./symbol_1.png": "c338",
	"./symbol_2.png": "8b70",
	"./symbol_3.png": "9115",
	"./symbol_4.png": "4294",
	"./symbol_5.png": "fb2d",
	"./symbol_6.png": "4469",
	"./symbol_7.png": "1a4b",
	"./symbol_8.png": "c925",
	"./symbol_9.png": "67bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2530";